export default {
  hostApiTalent: process.env.REACT_APP_URL_BASE,
};
